import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, UserProvider } from "@/context";
import AuthLayout from "@/layouts/AuthLayout";
import AdminLayout from "@/layouts/AdminLayout";
import { Login } from "@/pages/auth";
import { NotFound } from "@/pages/static";
import { getFlattenedRoutes, printRoutes } from "@/routes";
import PrintLayout from "@/layouts/PrintLayout";
import PermissionGuard from "@/components/auth/PermissionGuard";

const App = () => {
    // Generate simple flat routes for the router
    const flatRoutes = getFlattenedRoutes();

    return (
        <ThemeProvider>
            <UserProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Auth Routes */}
                        <Route element={<AuthLayout />}>
                            <Route path="/login" element={<Login />} />
                        </Route>

                        {/* Print Routes (no sidebar) */}
                        <Route element={<PrintLayout />}>
                            {printRoutes.map((route, index) => (
                                <Route
                                    key={`print-${index}`}
                                    element={
                                        <PermissionGuard
                                            permission={route.permission}
                                        />
                                    }
                                >
                                    <Route
                                        path={route.path}
                                        element={route.component}
                                    />
                                </Route>
                            ))}
                        </Route>

                        {/* Dashboard Routes with Permission Guard */}
                        <Route element={<AdminLayout />}>
                            {flatRoutes.map((route, index) => (
                                <Route
                                    key={index}
                                    element={
                                        <PermissionGuard
                                            permission={route.permission}
                                        />
                                    }
                                >
                                    <Route
                                        path={route.path}
                                        element={route.component}
                                    />
                                </Route>
                            ))}

                            {/* Special Routes */}
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </UserProvider>
        </ThemeProvider>
    );
};

export default App;
